import { z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const FileTypesDataSchemas = zod.object({
    fileTypeId: zod.number(),
    fileTypeName: zod.string(),
})

export const FileTypesAPISchemas =
    DefaultSchemas.merge(
        zod.object({
            fileTypes: zod.array(FileTypesDataSchemas),
        })
    )

export type FileTypesAPITypes = zod.infer<
    typeof FileTypesAPISchemas
>

export const FilesDataSchemas = zod.object({
    instanceId: zod.number(),
    fileName: zod.string(),
    recordCount: zod.number(),
    creationDate: zod.string(),
})

export const FilesAPISchemas =
    DefaultSchemas.merge(
        zod.object({
            files: zod.array(FilesDataSchemas),
        })
    )

export type FilesAPITypes = zod.infer<
    typeof FilesAPISchemas
>

export const FileCreateFormSchemas = zod.object({
    fileName: zod.string(),
})

export type FileCreateFormTypes = zod.infer<typeof FileCreateFormSchemas>;
export type FileTypesDataTypes = zod.infer<typeof FileTypesDataSchemas>;
export type FilesDataTypes = zod.infer<typeof FilesDataSchemas>;
